import { z } from 'zod';
import { organizationInputSchema } from './organization.js';
import { passwordSchema } from './session.js';

/**
 * 初始化请求。
 *
 * 没有凭据：库是空的时候 `/setup` 就是开着的，谁打开谁初始化。
 * 产品开发初期这样最省事，正式发布前再讨论要不要给这个窗口加一道门。
 *
 * 「只能成功一次」不受影响——那件事由数据库的唯一约束保证，不靠凭据。
 */
export const setupRequestSchema = z.object({
  organization: organizationInputSchema,
  admin: z.object({
    name: z.string().trim().min(1, '请填写姓名').max(60),
    email: z.string().trim().toLowerCase().email('请填写可用的邮箱地址'),
    password: passwordSchema,
  }),
});

export type SetupRequest = z.infer<typeof setupRequestSchema>;

/**
 * 首屏探测：前端拿它决定去 /setup 还是 /login。
 *
 * 未初始化时不返回任何企业信息——那时候还没有企业，而且这个接口是公开的。
 */
export const bootstrapSchema = z.object({
  initialized: z.boolean(),
  /** 只在已初始化后有值，登录页要显示企业名。 */
  organizationName: z.string().nullable(),
  /** 顶栏那枚等宽小标签，同样只在已初始化后有值。 */
  organizationCode: z.string().nullable(),
  /** 发信通道配没配，决定验证码登录和忘记密码能不能用。 */
  mailConfigured: z.boolean(),
});

export type Bootstrap = z.infer<typeof bootstrapSchema>;
